var _rect, _mask, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLi = function SvgLi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 20"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    fill: "#fff",
    rx: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "LI_svg__a",
    width: 28,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    fill: "#fff",
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#LI_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0a3b97",
    fillRule: "evenodd",
    d: "M0 10.667h28V0H0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6273e",
    fillRule: "evenodd",
    d: "M0 20h28v-9.333H0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#LI_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#002b7f",
    d: "M33.333 0H0v20h33.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M33.333 10H0v10h33.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    d: "m7.212 4.076-.061 2.083H5.037c-.26-.505-.475-.935-.475-1.516 0-.487.383-.873.934-.873.584 0 1.226.196 1.716.306M4.814 4.172v1.203Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M4.814 4.172v1.203"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    d: "M4.984 4.05v1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M4.984 4.05v1.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    d: "M5.154 3.965v1.908Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M5.154 3.965v1.908"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    d: "M5.324 3.926v1.496Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M5.324 3.926v1.496"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    d: "M5.494 3.918V5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M5.494 3.918V5.43"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    d: "M5.664 3.866v1.563Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M5.664 3.866v1.563"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    d: "M5.834 3.866v1.563Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M5.834 3.866v1.563"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    d: "M6.003 3.88v1.564Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M6.003 3.88v1.564"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    d: "M6.173 3.896V5.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M6.173 3.896V5.46"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    d: "M6.343 3.996V5.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M6.343 3.996V5.56"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    d: "M6.512 4.011v1.762Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M6.512 4.011v1.762"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    d: "M6.682 4.011v1.563Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M6.682 4.011v1.563"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    d: "M6.852 4.011v1.563Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M6.852 4.011v1.563"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M5.88 3.931c.358.06 1.146.428 1.056.927-.127.707-.54.423-1.087.322l-.414.137c-.148.152-.366.29-.513.108h-.245v.957h2.711V4.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.067,
    d: "M7.093 3.93a.165.165 0 1 0 0-.329.165.165 0 0 0 0 .33M6.723 3.842a.165.165 0 1 0 0-.33.165.165 0 0 0 0 .33M6.348 3.747a.165.165 0 1 0 0-.329.165.165 0 0 0 0 .33M5.97 3.684a.165.165 0 1 0 0-.329.165.165 0 0 0 0 .33M5.594 3.647a.165.165 0 1 0 0-.33.165.165 0 0 0 0 .33M5.225 3.668a.165.165 0 1 0 0-.33.165.165 0 0 0 0 .33M4.872 3.789a.165.165 0 1 0 0-.33.165.165 0 0 0 0 .33M4.575 4.007a.165.165 0 1 0 0-.33.165.165 0 0 0 0 .33M4.365 4.312a.165.165 0 1 0 0-.33.165.165 0 0 0 0 .33M4.263 4.67a.165.165 0 1 0 0-.33.165.165 0 0 0 0 .33M4.267 5.041a.165.165 0 1 0 0-.33.165.165 0 0 0 0 .33M4.338 5.405a.165.165 0 1 0 0-.33.165.165 0 0 0 0 .33"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.067,
    d: "m7.166 3.984-.015.215c-.41-.063-.99-.291-1.532-.291-.5 0-.889.2-.889.704 0 .497.21.95.49 1.41l-.29.137c-.26-.505-.475-.935-.475-1.516 0-.487.382-.965 1.041-.965.584 0 1.18.197 1.67.306"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    d: "m7.585 4.076.061 2.083H9.76c.26-.505.475-.935.475-1.516 0-.487-.383-.873-.935-.873-.584 0-1.225.196-1.715.306M9.982 4.172v1.203Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M9.982 4.172v1.203"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    d: "M9.812 4.05v1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M9.812 4.05v1.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    d: "M9.642 3.965v1.908Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M9.642 3.965v1.908"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    d: "M9.473 3.926v1.496Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M9.473 3.926v1.496"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    d: "M9.303 3.918V5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M9.303 3.918V5.43"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    d: "M9.133 3.866v1.563Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M9.133 3.866v1.563"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    d: "M8.963 3.866v1.563Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M8.963 3.866v1.563"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    d: "M8.793 3.88v1.564Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M8.793 3.88v1.564"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    d: "M8.624 3.896V5.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M8.624 3.896V5.46"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    d: "M8.454 3.996V5.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M8.454 3.996V5.56"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    d: "M8.284 4.011v1.762Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M8.284 4.011v1.762"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    d: "M8.114 4.011v1.563Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M8.114 4.011v1.563"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    d: "M7.944 4.011v1.563Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M7.944 4.011v1.563"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M8.917 3.931c-.359.06-1.147.428-1.057.927.128.707.54.423 1.088.322l.413.137c.148.152.366.29.514.108h.245v.957H7.408V4.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.067,
    d: "M7.703 3.93a.165.165 0 1 1 0-.329.165.165 0 0 1 0 .33M8.074 3.842a.165.165 0 1 1 0-.33.165.165 0 0 1 0 .33M8.45 3.747a.165.165 0 1 1 0-.329.165.165 0 0 1 0 .33M8.826 3.684a.165.165 0 1 1 0-.329.165.165 0 0 1 0 .33M9.203 3.647a.165.165 0 1 1 0-.33.165.165 0 0 1 0 .33M9.572 3.668a.165.165 0 1 1 0-.33.165.165 0 0 1 0 .33M9.925 3.789a.165.165 0 1 1 0-.33.165.165 0 0 1 0 .33M10.222 4.007a.165.165 0 1 1 0-.33.165.165 0 0 1 0 .33M10.432 4.312a.165.165 0 1 1 0-.33.165.165 0 0 1 0 .33M10.534 4.67a.165.165 0 1 1 0-.33.165.165 0 0 1 0 .33M10.53 5.041a.165.165 0 1 1 0-.33.165.165 0 0 1 0 .33M10.459 5.405a.165.165 0 1 1 0-.33.165.165 0 0 1 0 .33"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.067,
    d: "m7.63 3.984.016.215c.41-.063.99-.291 1.532-.291.5 0 .888.2.888.704 0 .497-.21.95-.49 1.41l.291.137c.26-.505.475-.935.475-1.516 0-.487-.382-.965-1.041-.965-.584 0-1.18.197-1.67.306M7.398 1.77l-.171.322.171.321.172-.32Zm0 .813-.171.32.171.323.172-.322zM6.786 2.498l.27.172.27-.172-.27-.172Zm.684 0 .27.172.271-.172-.271-.172Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.067,
    d: "M7.399 2.632a.13.13 0 1 0 0-.26.13.13 0 0 0 0 .26M7.399 3.681a.349.349 0 1 0 0-.697.349.349 0 0 0 0 .697"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "m7.311 2.996-.001.22a2 2 0 0 0-.248.026m.673 0a2 2 0 0 0-.248-.026v-.22m-.426.423a2 2 0 0 1 .675 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.067,
    d: "M7.058 3.922c-.033.57-.1 1.15-.322 1.571l.36-.146c.126-.477.153-1.094.19-1.386Zm.681 0-.23.039c.04.292.066.909.191 1.386l.36.146c-.22-.421-.288-1.001-.321-1.57"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.067,
    d: "M7.398 5.156c-.43 0-.747.203-.766.72-.105-.186-.55-.768-.965-.69-.247.046-.465.389-.428.781-.205-.587-.804-.684-1.24-.336.387.319.56 1.26.887 1.67H9.91c.326-.41.5-1.351.888-1.67-.437-.348-1.036-.251-1.24.336.037-.392-.183-.735-.43-.781-.415-.078-.86.504-.964.69-.02-.517-.337-.72-.767-.72"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M9.903 7.3c0 .187-1.122.391-2.504.391-1.383 0-2.505-.204-2.505-.39s1.122-.284 2.505-.284 2.504.097 2.504.283"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "M7.399 3.931a.117.117 0 1 0 0-.233.117.117 0 0 0 0 .233M7.398 4.192a.124.124 0 1 0 0-.25.124.124 0 0 0 0 .25M7.399 4.475a.136.136 0 1 0 0-.272.136.136 0 0 0 0 .272M7.399 4.797a.155.155 0 1 0 0-.31.155.155 0 0 0 0 .31M7.398 5.149a.17.17 0 1 0 0-.34.17.17 0 0 0 0 .34"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M7.33 5.307c-.018 0-.035.015-.03.044l.018.144c.008.05.037.038.044 0 .007-.04.004-.064.006-.136.001-.036-.019-.052-.037-.052m.136 0c-.018 0-.038.016-.037.052.002.072-.001.096.006.135s.036.051.044.001l.018-.144c.005-.03-.012-.045-.03-.044m-.256.018c-.017.003-.034.02-.033.038.002.033.01.073.014.123s.04.031.044.002a.7.7 0 0 0 .004-.13q-.003-.031-.022-.033zm.37 0q-.018.001-.022.033c-.004.057 0 .1.004.13s.04.05.044-.002c.003-.05.013-.09.014-.123.001-.018-.016-.035-.033-.038zm-.515.059a.04.04 0 0 0-.025.043c.01.043.018.09.018.133 0 .037.031.023.033-.002s.005-.08.005-.13c0-.038-.015-.048-.03-.044m.656 0c-.01.003-.02.016-.02.043 0 .05.003.105.005.13s.033.04.033.003c0-.043.009-.09.018-.133a.04.04 0 0 0-.025-.043zm-1.97.005c-.018 0-.03.025-.018.053.02.044.042.072.062.12.019.042.047.015.038-.014-.01-.03-.02-.063-.047-.125q-.016-.034-.034-.034m3.294 0q-.017-.001-.034.034c-.028.062-.038.095-.047.125s.02.056.038.013c.02-.047.042-.075.062-.12.013-.027 0-.052-.019-.052m-3.16.003c-.014.004-.022.02-.014.041.017.04.041.082.058.126.014.039.047.028.036-.007-.01-.035-.014-.056-.036-.122-.011-.033-.03-.043-.044-.038m3.017 0q-.02.002-.034.038c-.022.066-.025.087-.036.122s.022.046.036.007c.017-.044.041-.085.058-.126.008-.02 0-.037-.014-.041zm-2.85.032c-.017.003-.03.03-.02.061q.026.059.055.125c.019.046.05.037.042.008-.008-.03-.017-.079-.039-.153q-.017-.047-.038-.041m2.693 0q-.021-.005-.038.041c-.022.074-.031.123-.039.153-.007.029.024.038.042-.008s.04-.084.054-.125c.012-.032-.001-.058-.019-.061m-3.106.023c-.018.002-.035.032-.024.055.019.037.03.05.048.088.019.041.039.01.031-.016l-.026-.093c-.006-.027-.018-.035-.029-.034m3.519 0c-.011-.001-.022.007-.03.034q-.013.055-.025.093c-.008.026.013.057.031.016.018-.039.03-.051.048-.088.011-.023-.006-.053-.024-.055m-2.234.093c-.02 0-.04.026-.034.05.011.039.028.073.04.123.012.044.043.022.041-.007a1 1 0 0 0-.02-.133c-.004-.023-.016-.033-.027-.033m.95 0q-.02 0-.029.033a1 1 0 0 0-.02.133c-.001.03.03.051.041.007.013-.05.03-.084.04-.123.008-.024-.013-.05-.032-.05m-.475.04c-.024 0-.028.032-.029.058a.4.4 0 0 1-.068.21c-.03.042-.076.03-.117.009a1 1 0 0 1-.11-.072c-.045-.033-.078-.014-.025.061.154.22.32.407.32.765 0 .046.008.06.029.06.02 0 .029-.014.029-.06 0-.358.166-.545.32-.765.052-.075.019-.094-.026-.061a1 1 0 0 1-.11.072c-.041.022-.086.033-.117-.009a.4.4 0 0 1-.068-.21c-.001-.026-.004-.058-.028-.058m-1.176-.054h-.007q-.015.006-.011.033c.006.034.03.1.038.13.01.032.048.025.039-.017s-.009-.055-.02-.103c-.006-.027-.025-.043-.04-.043m2.352 0c-.015 0-.034.016-.04.043-.011.048-.01.06-.02.103-.009.042.03.049.039.017.009-.03.032-.096.038-.13q.004-.028-.011-.032zm-3.051.013c-.02.002-.034.026-.014.062.021.038.057.087.074.114s.045.01.025-.026-.027-.075-.051-.125q-.016-.026-.034-.025m3.75 0q-.02-.001-.035.025c-.024.05-.03.09-.05.125s.008.054.024.026c.017-.027.053-.076.074-.114.02-.036.006-.06-.013-.062m-4.807.111c-.022 0-.029.04-.008.066.03.039.052.06.086.09.028.026.036-.007.022-.032s-.034-.05-.061-.091q-.023-.033-.039-.033m5.863 0q-.016 0-.039.033c-.027.041-.047.066-.061.091s-.006.058.022.033a.6.6 0 0 0 .086-.091c.021-.027.014-.067-.008-.066m-5.695.034c-.018 0-.03.013-.016.043.02.044.046.093.063.127.016.033.067.044.047-.008-.02-.051-.025-.078-.043-.126a.06.06 0 0 0-.051-.036m5.527 0a.06.06 0 0 0-.051.036c-.018.048-.022.075-.043.126s.03.04.047.008c.017-.034.043-.083.063-.127.013-.03.002-.043-.016-.043m-5.852.011c-.026 0-.028.026-.005.043q.046.033.102.075c.041.033.057.003.035-.025s-.043-.056-.099-.083a.1.1 0 0 0-.033-.01m6.177 0a.1.1 0 0 0-.033.01c-.056.027-.077.055-.1.083-.021.028-.005.058.036.025q.056-.042.102-.075c.023-.017.02-.043-.005-.043m-3.655.024c-.015.002-.027.019-.021.04.011.038.024.08.031.12.008.038.052.039.045.004s-.011-.08-.024-.133q-.009-.03-.025-.03zm1.127 0q-.016.002-.025.031c-.013.054-.017.098-.024.133s.037.034.045-.004c.007-.04.02-.082.031-.12.006-.021-.006-.038-.02-.04zm-2.13-.066c-.012.003-.018.025-.01.055.047.169.062.258.053.3-.008.04-.03.046-.061.032a1 1 0 0 1-.094-.053c-.027-.019-.056.004-.016.037.201.166.341.355.395.585.012.047.041.053.033 0-.046-.29-.055-.528.014-.677.026-.056 0-.11-.041-.019-.028.061-.073.085-.109.033a1.6 1.6 0 0 1-.132-.257q-.013-.034-.027-.036zm3.134 0q-.014.002-.027.036a1.6 1.6 0 0 1-.132.257c-.036.052-.08.028-.109-.033-.041-.09-.067-.037-.041.02.069.148.06.387.014.676-.008.053.022.047.033 0 .054-.23.194-.42.395-.585.04-.033.011-.056-.016-.037a1 1 0 0 1-.094.053c-.03.014-.053.009-.061-.033-.009-.041.006-.13.053-.299.008-.03.002-.052-.01-.055zm-4.149.08c-.018.001-.033.014-.025.041.013.045.041.093.05.12.01.028.039.015.033-.024l-.015-.104c-.004-.021-.025-.032-.043-.032m5.169 0c-.018 0-.04.012-.043.033l-.015.104c-.006.039.024.052.033.024s.037-.075.05-.12c.008-.027-.007-.04-.025-.04M5.44 5.677c-.021-.004-.024.05-.006.073.024.03.057.065.09.105.028.033.045.004.029-.024-.017-.028-.041-.057-.086-.127q-.016-.026-.027-.027m3.917 0q-.01.002-.027.027c-.044.07-.069.1-.086.127-.016.028 0 .057.029.024l.09-.105c.018-.022.015-.077-.006-.073m-4.4.132c-.013-.001-.024.01-.019.036.008.037.019.068.028.103S5 5.977 5 5.943q-.002-.051-.012-.105a.04.04 0 0 0-.031-.03m4.883 0a.04.04 0 0 0-.031.03q-.01.054-.011.105c0 .033.024.04.033.004.01-.035.02-.066.028-.103.005-.027-.006-.037-.019-.036m-4.447.047c-.02.003-.038.023-.014.054.038.05.08.085.096.103.014.019.052.012.028-.027-.025-.04-.062-.087-.078-.116q-.012-.017-.032-.014m4.002 0a.03.03 0 0 0-.022.014c-.017.03-.054.077-.079.116-.024.039.014.046.028.027.015-.018.058-.053.096-.103.025-.03.006-.05-.014-.054zm-4.69.14c-.016-.002-.022.01 0 .04.05.069.104.172.108.216s-.018.044-.038.044c-.061 0-.091-.044-.146-.057-.056-.013-.064.016-.024.045.203.147.406.312.487.461.033.061.078.083.053.025-.076-.178-.094-.328-.078-.42.017-.09.04-.152.037-.205s-.033-.049-.045 0a.4.4 0 0 1-.035.094c-.012.016-.056.026-.098-.031a1.6 1.6 0 0 0-.185-.195.1.1 0 0 0-.036-.018m5.387 0a.1.1 0 0 0-.036.017 1.6 1.6 0 0 0-.185.195c-.042.057-.086.047-.097.03a.4.4 0 0 1-.036-.093c-.012-.049-.042-.052-.045 0-.002.053.02.114.037.205.016.092-.002.242-.078.42-.025.058.02.036.053-.025.081-.15.285-.314.487-.461.04-.029.032-.058-.024-.045-.055.013-.085.057-.145.057-.02 0-.043 0-.039-.044a.6.6 0 0 1 .108-.215c.022-.03.017-.043 0-.042"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    d: "m5.004 7.088.065.206Zm.134-.039.057.208zm.144-.024.04.213ZM5.416 7l.042.211Zm.172-.017.034.213Zm.183 0 .037.212zm.178-.06.027.214Zm.168.01.027.214Zm.163-.021.026.214Zm.163-.017.014.215Zm.174 0 .013.215zm.158-.011.01.215Zm.174-.011.01.216Zm.2-.005.01.215Zm2.644.221-.065.206zM9.66 7.05l-.058.208Zm-.145-.024-.04.213ZM9.381 7l-.042.211Zm-.172-.017-.034.213Zm-.182 0-.037.212Zm-.179-.06-.027.214Zm-.168.01-.027.214Zm-.162-.021-.027.214Zm-.163-.017-.015.215Zm-.175 0-.012.215Zm-.158-.011-.01.215Zm-.174-.011-.009.216Zm-.2-.005-.01.215Zm-.25-.014v.237z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.05,
    d: "m5.004 7.088.065.206m.069-.245.057.208m.087-.232.04.213m.094-.24.042.212m.13-.228.034.213m.149-.213.037.212m.141-.273.027.215m.141-.204.027.214m.136-.235.026.214m.137-.231.014.215m.16-.215.013.215m.145-.226.01.215m.164-.226.01.216m.19-.221.01.215m2.634.006-.065.206m-.068-.245-.058.208m-.087-.232-.04.213m-.094-.24-.042.212m-.13-.228-.034.213m-.148-.213-.037.212m-.142-.273-.027.215m-.14-.204-.028.214m-.135-.235-.027.214m-.136-.231-.015.215m-.16-.215-.012.215m-.146-.226-.01.215m-.164-.226-.009.216m-.191-.221-.01.215m-.24-.23v.238"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "LI_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h33.333v20H0z"
  })))));
};
export { SvgLi as ReactComponent };
export default __webpack_public_path__ + "static/LI.69b0ae81.svg";